import React from "react";

import { Container, Flex, Image, useColorMode } from "theme-ui";

import iconThemeDark from "../assets/images/icon-theme-dark.svg";
import iconThemeLight from "../assets/images/icon-theme-light.svg";
import useResponsive, { DisplaySize } from "../hooks/useResponsive";
// import { useScrollPosition } from "../hooks/useScrollPosition";
import { AstridDaoLogo } from "./AstridDaoLogo";
import { Balance } from "./Balance";
import { ConvertWastrButton } from "./ConvertWastr/ConvertWastrButton";
import { SideNav } from "./SideNav";

export const Header: React.FC = () => {
  // const scrollPosition = useScrollPosition();
  const responsive = useResponsive();
  const [colorMode, setColorMode] = useColorMode();

  return (
    <Container
      variant="header"
      sx={{
        background: "W100"
      }}
    >
      {responsive >= DisplaySize.ComputerS ? (
        <>
          <Flex
            sx={{
              gap: 3,
              display: "flex"
            }}
          >
            <ConvertWastrButton />
            <Balance ignoreClick />
            <Balance showWalletAddress />
          </Flex>
          <Flex
            sx={{
              justifyContent: "center",
              alignItems: "center",
              background: "G08",
              width: "40px",
              height: "40px",
              ml: "10px",
              borderRadius: "16px",
              cursor: "pointer",
              ":hover": {
                background: "G40"
              }
            }}
          >
            <Image
              src={colorMode === "light" ? iconThemeLight : iconThemeDark}
              sx={{
                width: "24px",
                height: "24px"
              }}
              onClick={() => {
                // change color mode to next color mode
                setColorMode(colorMode === "light" ? "dark" : "light");
              }}
            />
          </Flex>
        </>
      ) : (
        <Flex
          sx={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3
          }}
        >
          <Flex sx={{ flexDirection: "row" }}>
            <SideNav />
            <AstridDaoLogo />
          </Flex>
          <Flex sx={{ flexDirection: "row" }}>
            <ConvertWastrButton mini />
            <Balance showWalletAddress mini />
          </Flex>
        </Flex>
      )}
    </Container>
  );
};
